export default "__VITE_ASSET__CPwK2QK1__"